import { createSelector } from 'reselect';
import { Map } from 'immutable';

import { getCurrentBook, getCurrentBookSpreads } from 'redux/selectors/books';
import { canEdit, getChildBirthday, getChildName } from 'redux/selectors/orders';
import { isAuthenticated } from 'redux/selectors/user';

export const selectLocationState = () => {
  let prevRoutingState;
  let prevRoutingStateJS;

  return state => {
    const routingState = state.get('route'); // or state.route

    if (!routingState.equals(prevRoutingState)) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }

    return prevRoutingStateJS;
  };
};

export const getActiveOrderId = state => state.getIn(['app', 'activeOrderId'], null);
export const getActiveSpreadId = state => {
  const firstSpread = getCurrentBookSpreads(state).getIn([0, 'id']);
  return state.getIn(['app', 'activeSpreadIds', getActiveOrderId(state)]) || firstSpread;
};
export const getActiveSpreadName = state => {
  const book = getCurrentBook(state);
  const activeSpreadId = getActiveSpreadId(state);
  const spread = book.get('spreads').find(spread => spread.get('id') === activeSpreadId);

  return spread.get('label');
};
export const getActiveBookId = state => state.getIn(['orders', getActiveOrderId(state), 'book'], null);

export const getOrderValidation = state => state.getIn(['app', 'orderValidation', getActiveOrderId(state)], Map());

export const isUploading = state => state.getIn(['app', 'ui', 'is_uploading'], false);

export const getSidebar = state => state.getIn(['app', 'sidebar']);

export const forcedSidebar = createSelector(
  [getSidebar, getActiveOrderId, canEdit, isAuthenticated, getChildName, getChildBirthday],
  (sidebar, orderId, canEdit, authenticated, name, birthday) => {
    if (orderId && (!sidebar || sidebar === 'photos') && !canEdit) {
      sidebar = 'order';
    } else if (!orderId && (!sidebar || sidebar === 'photos')) {
      sidebar = 'myOrders';
    } else if (orderId && canEdit && (!name || !birthday)) {
      sidebar = sidebar === 'saveSuccess' ? sidebar : 'child';
    }

    if (sidebar === 'login' && authenticated) {
      sidebar = 'profile';
    } else if (sidebar === 'profile' && !authenticated) {
      sidebar = 'login';
    }

    return sidebar || 'photos';
  }
);



// WEBPACK FOOTER //
// ./app/redux/selectors/app.js